import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
let codeCENTRAL = apiConstants.codeCENTRAL;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                menu: {
                    route: `${code.replace(new RegExp(`${CITYHUB_MANAGE_SUFFIX}$`), '')}.home`,
                    text: 'Home',
                    icon: 'fas fa-home'
                },
                acl: {
                    view: 'COSI_00582'
                }
            },
            central: {
                menu: {
                    route: `${codeCENTRAL}.home`,
                    text: 'Central',
                    icon: 'fas fa-headset'
                },
                acl: {
                    view: 'COSI_00007'
                }
            },
            default_layers: {
                menu: {
                    route: `${code}.default_layers`,
                    text: 'default_layers.titles',
                    icon: 'fas fa-layer-group',
                },
                acl: {
                    view                    : 'MB_00646',
                    detail                  : 'MB_00647',
                    add                     : 'MB_00648',
                    edit                    : 'MB_00649',
                    delete                  : 'MB_00650',
                },
                url: {
                    getList                 : `${codeAPI}/gestao/defaultlayers`,
                    getShow                 : `${codeAPI}/gestao/defaultlayers/:id`,
                    getCreate               : `${codeAPI}/gestao/defaultlayers`,
                    getUpdate               : `${codeAPI}/gestao/defaultlayers/:id`,
                    getDelete               : `${codeAPI}/gestao/defaultlayers/:id`,
                    getLists                : `${codeAPI}/gestao/defaultlayers/lists`,
                    getResources            : `/backoffice/gestao/ogc/remoteservices/resources`,
                },
            },
            layers: {
                active: true,
                menu: {
                    route: `${code}.layers`,
                    text: 'layers.titles',
                    icon: 'fas fa-layer-group'
                },
                acl: {
                    view: 'COSI_00548',
                    detail: 'COSI_00549',
                    add: 'COSI_00551',
                    edit: 'COSI_00552',
                    delete: 'COSI_00550',
                    private: 'COSI_00553'
                },
                url: {
                    getList: `${codeAPI}/gestao/layers`,
                    getShow: `${codeAPI}/gestao/layers/:id`,
                    getCreate: `${codeAPI}/gestao/layers`,
                    getUpdate: `${codeAPI}/gestao/layers/:id`,
                    getDelete: `${codeAPI}/gestao/layers/:id`,
                    getLists: `${codeAPI}/gestao/layers/lists`,
                    getResources: `${codeAPI}/gestao/layers/resources`,
                    describeResource: `${codeAPI}/gestao/layers/resources/:id/describe`,
                }
            },
            families: {
                active: true,
                menu: {
                    route: `${code}.families`,
                    text: 'families.titles',
                    icon: 'fas fa-tasks'
                },
                acl: {
                    view: 'COSI_00660',
                    detail: 'COSI_00661',
                    add: 'COSI_00662',
                    edit: 'COSI_00663',
                    delete: 'COSI_00664'
                },
                url: {
                    getList: `${codeAPI}/gestao/families`,
                    getShow: `${codeAPI}/gestao/families/:id`,
                    getCreate: `${codeAPI}/gestao/families`,
                    getUpdate: `${codeAPI}/gestao/families/:id`,
                    getDelete: `${codeAPI}/gestao/families/:id`
                }
            },
            kinds: {
                active: true,
                menu: {
                    route: `${code}.kinds`,
                    text: 'kinds.titles',
                    icon: 'fas fa-tasks'
                },
                acl: {
                    view: 'COSI_00670',
                    detail: 'COSI_00671',
                    add: 'COSI_00672',
                    edit: 'COSI_00673',
                    delete: 'COSI_00674'
                },
                url: {
                    getList: `${codeAPI}/gestao/kinds`,
                    getShow: `${codeAPI}/gestao/kinds/:id`,
                    getCreate: `${codeAPI}/gestao/kinds`,
                    getUpdate: `${codeAPI}/gestao/kinds/:id`,
                    getDelete: `${codeAPI}/gestao/kinds/:id`,
                    getFamilies: `${codeAPI}/gestao/kinds/families`
                }
            },
            types: {
                active: true,
                menu: {
                    route: `${code}.types`,
                    text: 'types.titles',
                    icon: 'fas fa-tasks'
                },
                enableEdocLink: false,
                acl: {
                    view: 'COSI_00032',
                    detail: 'COSI_00033',
                    add: 'COSI_00035',
                    edit: 'COSI_00036',
                    delete: 'COSI_00034'
                },
                url: {
                    getList: `${codeAPI}/gestao/types`,
                    getShow: `${codeAPI}/gestao/types/:id`,
                    getCreate: `${codeAPI}/gestao/types`,
                    getUpdate: `${codeAPI}/gestao/types/:id`,
                    getDelete: `${codeAPI}/gestao/types/:id`,
                    getLists: `${codeAPI}/gestao/types/lists`
                }
            },
            entities: {
                active: true,
                menu: {
                    route: `${code}.entities`,
                    text: 'entities.titles',
                    icon: 'fas fa-stream'
                },
                acl: {
                    view: 'COSI_00027',
                    detail: 'COSI_00028',
                    add: 'COSI_00030',
                    edit: 'COSI_00031',
                    delete: 'COSI_00029'
                },
                url: {
                    getList: `${codeAPI}/gestao/entities`,
                    getShow: `${codeAPI}/gestao/entities/:id`,
                    getCreate: `${codeAPI}/gestao/entities`,
                    getUpdate: `${codeAPI}/gestao/entities/:id`,
                    getDelete: `${codeAPI}/gestao/entities/:id`
                }
            },
            unities: {
                active: true,
                menu: {
                    route: `${code}.unities`,
                    text: 'unities.titles',
                    icon: 'fas fa-stream'
                },
                panel: {
                    maxFiles: 5,
                    mimeTypes: [
                        'application/msword', //.doc
                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document', //.docx
                        'application/vnd.ms-excel', //.xls
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', //.xlsx
                        'application/vnd.ms-powerpoint', //.ppt
                        'application/vnd.openxmlformats-officedocument.presentationml.presentation', //.pptx
                        'application/pdf',
                        'text/plain',
                        'image/x-png',
                        'image/bmp',
                        'image/jpeg',
                        'image/jpg',
                        'image/gif'
                    ],
                    agents: {
                        query: null,
                        label: 'full_name',
                        labelTemplate: '<p><strong>${full_name}</strong></p><p><small>${unities_label}</small></p>'
                    },
                    vehicles: {
                        query: null,
                        label: 'full_name',
                        labelTemplate: '<p><strong>${full_name}</strong></p>'
                    },
                    radios: {
                        query: null,
                        label: 'full_name',
                        labelTemplate: '<p><strong>${full_name}</strong></p><p><small>${unities_label}</small></p>'
                    }
                },
                acl: {
                    view: 'COSI_00022',
                    detail: 'COSI_00023',
                    add: 'COSI_00025',
                    edit: 'COSI_00026',
                    delete: 'COSI_00024'
                },
                url: {
                    getList: `${codeAPI}/gestao/unities`,
                    getShow: `${codeAPI}/gestao/unities/:id`,
                    getCreate: `${codeAPI}/gestao/unities`,
                    getUpdate: `${codeAPI}/gestao/unities/:id`,
                    getDelete: `${codeAPI}/gestao/unities/:id`,
                    getLists: `${codeAPI}/gestao/unities/lists`,
                    searchAgent: `${codeAPI}/gestao/unities/search/agent`,
                    getAgents: `${codeAPI}/gestao/unities/:id/agents`,
                    searchVehicle: `${codeAPI}/gestao/unities/search/vehicle`,
                    getVehicles: `${codeAPI}/gestao/unities/:id/vehicles`,
                    searchRadio: `${codeAPI}/gestao/unities/search/radio`,
                    getRadios: `${codeAPI}/gestao/unities/:id/radios`
                }
            },
            channels: {
                active: true,
                menu: {
                    route: `${code}.channels`,
                    text: 'channels.titles',
                    icon: 'fas fa-keyboard'
                },
                acl: {
                    view: 'COSI_00042',
                    detail: 'COSI_00043',
                    add: 'COSI_00045',
                    edit: 'COSI_00046',
                    delete: 'COSI_00044'
                },
                url: {
                    getList: `${codeAPI}/gestao/channels`,
                    getShow: `${codeAPI}/gestao/channels/:id`,
                    getCreate: `${codeAPI}/gestao/channels`,
                    getUpdate: `${codeAPI}/gestao/channels/:id`,
                    getDelete: `${codeAPI}/gestao/channels/:id`
                }
            },
            notifications: {
                menu: {
                    route: `${code}.notifications`,
                    text: 'notifications.titles',
                    icon: 'fas fa-envelope'
                },
                acl: {
                    view: 'COSI_00369',
                    detail: 'COSI_00370',
                    add: 'COSI_00373',
                    edit: 'COSI_00371',
                    delete: 'COSI_00372'
                },
                url: {
                    getList: `${codeAPI}/gestao/notifications`,
                    getShow: `${codeAPI}/gestao/notifications/:id`,
                    getCreate: `${codeAPI}/gestao/notifications`,
                    getUpdate: `${codeAPI}/gestao/notifications/:id`,
                    getDelete: `${codeAPI}/gestao/notifications/:id`,
                    getLists: `${codeAPI}/gestao/notifications/lists`
                }
            },
            statuses: {
                menu: {
                    route: `${code}.statuses`,
                    text: 'statuses.titles',
                    icon: 'fas fa-info-circle'
                },
                acl: {
                    view: 'COSI_00057',
                    detail: 'COSI_00058',
                    add: 'COSI_00050',
                    edit: 'COSI_00051',
                    delete: 'COSI_00059'
                },
                url: {
                    getList: `${codeAPI}/gestao/statuses`,
                    getShow: `${codeAPI}/gestao/statuses/:id`,
                    getCreate: `${codeAPI}/gestao/statuses`,
                    getUpdate: `${codeAPI}/gestao/statuses/:id`,
                    getDelete: `${codeAPI}/gestao/statuses/:id`,
                    getTransform: `${codeAPI}/gestao/statuses/transform`
                }
            },
            priorities: {
                active: true,
                menu: {
                    route: `${code}.priorities`,
                    text: 'priorities.titles',
                    icon: 'fas fa-wave-square'
                },
                acl: {
                    view: 'COSI_00027',
                    detail: 'COSI_00028',
                    add: 'COSI_00030',
                    edit: 'COSI_00031',
                    delete: 'COSI_00029'
                },
                url: {
                    getList: `${codeAPI}/gestao/priorities`,
                    getShow: `${codeAPI}/gestao/priorities/:id`,
                    getCreate: `${codeAPI}/gestao/priorities`,
                    getUpdate: `${codeAPI}/gestao/priorities/:id`,
                    getDelete: `${codeAPI}/gestao/priorities/:id`
                }
            },
            alarms: {
                active: true,
                menu: {
                    route: `${code}.alarms`,
                    text: 'alarms.titles',
                    icon: 'fas fa-tasks'
                },
                acl: {
                    view: 'COSI_00720',
                    detail: 'COSI_00721',
                    add: 'COSI_00722',
                    edit: 'COSI_00723',
                    delete: 'COSI_00724'
                },
                url: {
                    getList: `${codeAPI}/gestao/ccom/alarms`,
                    getShow: `${codeAPI}/gestao/ccom/alarms/:id`,
                    getCreate: `${codeAPI}/gestao/ccom/alarms`,
                    getUpdate: `${codeAPI}/gestao/ccom/alarms/:id`,
                    getDelete: `${codeAPI}/gestao/ccom/alarms/:id`
                }
            },
            expedients: {
                active: true,
                menu: {
                    route: `${code}.expedients`,
                    text: 'expedients.titles',
                    icon: 'fas fa-tasks'
                },
                acl: {
                    view: 'COSI_00730',
                    detail: 'COSI_00731',
                    add: 'COSI_00732',
                    edit: 'COSI_00733',
                    delete: 'COSI_00734'
                },
                url: {
                    getList: `${codeAPI}/gestao/ccom/expedients`,
                    getShow: `${codeAPI}/gestao/ccom/expedients/:id`,
                    getCreate: `${codeAPI}/gestao/ccom/expedients`,
                    getUpdate: `${codeAPI}/gestao/ccom/expedients/:id`,
                    getDelete: `${codeAPI}/gestao/ccom/expedients/:id`
                }
            },
            cps: {
                active: false,
                menu: {
                    route: `${code}.cps`,
                    text: 'cps.titles',
                    icon: 'fas fa-tasks'
                },
                acl: {
                    view: 'COSI_00740',
                    detail: 'COSI_00741',
                    add: 'COSI_00742',
                    edit: 'COSI_00743',
                    delete: 'COSI_00744'
                },
                url: {
                    getList: `${codeAPI}/gestao/ccom/cps`,
                    getShow: `${codeAPI}/gestao/ccom/cps/:id`,
                    getCreate: `${codeAPI}/gestao/ccom/cps`,
                    getUpdate: `${codeAPI}/gestao/ccom/cps/:id`,
                    getDelete: `${codeAPI}/gestao/ccom/cps/:id`,
                    getLists: `${codeAPI}/gestao/ccom/cps/lists `
                }
            },
            airbases: {
                active: false,
                menu: {
                    route: `${code}.airbases`,
                    text: 'airbases.titles',
                    icon: 'fas fa-plane-departure'
                },
                acl: {
                    view: 'COSI_00740',
                    detail: 'COSI_00741',
                    add: 'COSI_00742',
                    edit: 'COSI_00743',
                    delete: 'COSI_00744'
                },
                url: {
                    getList: `${codeAPI}/gestao/airbases`,
                    getShow: `${codeAPI}/gestao/airbases/:id`,
                    getCreate: `${codeAPI}/gestao/airbases`,
                    getUpdate: `${codeAPI}/gestao/airbases/:id`,
                    getDelete: `${codeAPI}/gestao/airbases/:id`,
                    getLists: `${codeAPI}/gestao/airbases/lists`
                }
            },
            category_types: {
                active: true,
                menu: {
                    route: `${code}.category_types`,
                    text: 'category_types.titles',
                    icon: 'fas fa-tasks'
                },
                acl: {
                    view: 'COSI_00745',
                    detail: 'COSI_00746',
                    add: 'COSI_00747',
                    edit: 'COSI_00748',
                    delete: 'COSI_00749'
                },
                url: {
                    getList: `${codeAPI}/gestao/categorytypes`,
                    getShow: `${codeAPI}/gestao/categorytypes/:id`,
                    getCreate: `${codeAPI}/gestao/categorytypes`,
                    getUpdate: `${codeAPI}/gestao/categorytypes/:id`,
                    getDelete: `${codeAPI}/gestao/categorytypes/:id`,
                    getLists: `${codeAPI}/gestao/categorytypes/lists `
                }
            }
        },
        tools: {}
    }
};

export default state;
